// src/subscreens/mechanicadmin/register/MechanicRegistrationPage.jsx

import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff, FiArrowRight, FiChevronDown, FiCheck } from "react-icons/fi";
import { FaWrench } from "react-icons/fa";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import mechanicImg from "../../../assets/images/home/hero3.jpg";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/mechanic/register/Register.css";

export default function MechanicRegistrationPage() {
  const navigate = useNavigate();
  const { baseUrl, regExpChecker } = useContext(AppContext);

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [specializationsList, setSpecializationsList] = useState([]);
  const [specialization, setSpecialization] = useState("");
  const [errormessage, setErrorMessage] = useState("");
  const [specDropdownOpen, setSpecDropdownOpen] = useState(false);

  // ── OTP flow states ──
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [pendingEmail, setPendingEmail] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);

  const specRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (specRef.current && !specRef.current.contains(e.target)) {
        setSpecDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSpecSelect = (spec) => {
    setSpecialization(spec);
    setSpecDropdownOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!fullname || !email || !password || !confirmPassword) {
      setErrorMessage("Please fill all fields");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    if (!specialization) {
      setErrorMessage("Please select your specialization");
      return;
    }

    setLoading(true);

    const formdata = new FormData();
    formdata.append("fullname", fullname);
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("specialization", specialization);

    axios.post(`${baseUrl}/mechanicadmin/authentication/signup`, formdata)
      .then(() => {
        setLoading(false);
        setPendingEmail(email);
        setOtpStep(true);
        setErrorMessage("");
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error.response?.data?.error || "Something went wrong. Please try again.");
      });
  };

  const handleVerifyOtp = () => {
    if (!otp) {
      setErrorMessage("Please enter the OTP");
      return;
    }
    setVerifyLoading(true);

    const formdata = new FormData();
    formdata.append("email", pendingEmail);
    formdata.append("otp", otp);

    axios.post(`${baseUrl}/mechanicadmin/authentication/verify-registration-otp`, formdata)
      .then(() => {
        setVerifyLoading(false);
        // 👇 auto-login nahi karna — seedha Login page pe bhej dein
        navigate("/mechanic-admin/login");
      })
      .catch((error) => {
        setVerifyLoading(false);
        setErrorMessage(error.response?.data?.error || "OTP verification failed");
      });
  };

  const handleResendOtp = () => {
    const formdata = new FormData();
    formdata.append("email", pendingEmail);

    axios.post(`${baseUrl}/mechanicadmin/authentication/resend-registration-otp`, formdata)
      .then(() => {
        setResendMessage("OTP resent to your email");
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.error || "Could not resend OTP");
      });
  };

  const fetchAllSpecializations = () => {
    axios
      .get(`${baseUrl}/mechanicadmin/specialization/fetchAllSpecializations`)
      .then((res) => {
        if (res.data.success == true) {
          setSpecializationsList(res.data.specialization.map(item => item.specializationname));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchAllSpecializations();
  }, []);

  return (
    <div className="mech-auth-container">

      {/* ── LEFT PANEL ── */}
      <div
        className="mech-auth-left"
        style={{ backgroundImage: `url(${mechanicImg})`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="mech-auth-overlay" />
        <div className="mech-auth-left-content">
          <span className="mech-badge">FOR SKILLED MECHANICS</span>
          <h1>Turn Your Skills Into <br /> Steady Income</h1>
          <p>Join Pakistan's leading agricultural machinery maintenance network. Get matched with farmers, manage jobs, and grow your business.</p>
        </div>
      </div>

      {/* ── RIGHT PANEL ── */}
      <div className="mech-auth-right">
        <div className="mech-form-scroll">
          <div className="mech-form-card">

            {!otpStep ? (
              <>
                <div className="mech-form-header">
                  <h2>Create Mechanic Account</h2>
                  <p>Fill in your details to join the mechanic network.</p>
                </div>

                <form onSubmit={handleSubmit}>

                  {/* Full Name */}
                  <div className="mech-form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      placeholder="e.g. Ali Hassan"
                      value={fullname}
                      onChange={(e) => { setFullname(e.target.value); setErrorMessage(regExpChecker("username", e.target.value)); }}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="mech-form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      placeholder="name@example.com"
                      value={email}
                      onChange={(e) => { setEmail(e.target.value); setErrorMessage(regExpChecker("email", e.target.value)); }}
                      required
                    />
                  </div>

                  {/* Passwords */}
                  <div className="mech-password-row">
                    <div className="mech-form-group">
                      <label>Password</label>
                      <div className="mech-input-eye">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={password}
                          onChange={(e) => { setPassword(e.target.value); setErrorMessage(regExpChecker("password", e.target.value)); }}
                          required
                        />
                        <button type="button" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>
                    <div className="mech-form-group">
                      <label>Confirm Password</label>
                      <div className="mech-input-eye">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setErrorMessage(e.target.value !== password ? "Passwords do not match" : "");
                          }}
                          required
                        />
                        <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* ── SPECIALIZATION SINGLE SELECT ── */}
                  <div className="mech-form-group" ref={specRef}>
                    <label>Select Specialization</label>

                    <div
                      className={`mech-select-trigger ${specDropdownOpen ? "open" : ""}`}
                      onClick={() => setSpecDropdownOpen(!specDropdownOpen)}
                    >
                      <span className={specialization ? "mech-trigger-selected" : ""}>
                        {specialization || "Choose your specialization..."}
                      </span>
                      <FiChevronDown className={`mech-chevron ${specDropdownOpen ? "rotate" : ""}`} />
                    </div>

                    {specDropdownOpen && (
                      <div className="mech-dropdown-list mech-single-list">
                        {specializationsList.map((spec) => (
                          <div
                            key={spec}
                            className={`mech-single-option ${specialization === spec ? "mech-option-active" : ""} ${spec === "All" ? "mech-option-all" : ""}`}
                            onClick={() => handleSpecSelect(spec)}
                          >
                            <FaWrench className="mech-option-icon" />
                            <span>{spec}</span>
                            {specialization === spec && <FiCheck className="mech-option-check" />}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {errormessage && <p className="mech-error-msg">{errormessage}</p>}

                  <button type="submit" className="mech-submit-btn" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                        Registering...
                      </>
                    ) : (
                      <>
                        Register Account <FiArrowRight />
                      </>
                    )}
                  </button>

                  <p className="mech-auth-switch">
                    Already have an account?{" "}
                    <span onClick={() => navigate("/mechanic-admin/login")}>Login</span>
                  </p>

                </form>
              </>
            ) : (
              <>
                <div className="mech-form-header">
                  <h2>Verify Your Email</h2>
                  <p>We sent a 6-digit code to <b>{pendingEmail}</b>. Enter it below to activate your account.</p>
                </div>

                <div className="mech-form-group">
                  <label>Enter OTP</label>
                  <input
                    type="text"
                    placeholder="6-digit code"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    maxLength={6}
                  />
                </div>

                {errormessage && <p className="mech-error-msg">{errormessage}</p>}
                {resendMessage && <p style={{ color: "green", fontSize: "0.85rem" }}>{resendMessage}</p>}

                <button type="button" className="mech-submit-btn" onClick={handleVerifyOtp} disabled={verifyLoading}>
                  {verifyLoading ? (
                    <>
                      <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                      Verifying...
                    </>
                  ) : (
                    <>
                      Verify OTP <FiArrowRight />
                    </>
                  )}
                </button>

                <p className="mech-auth-switch">
                  Didn't receive the code?{" "}
                  <span onClick={handleResendOtp}>Resend OTP</span>
                </p>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}